module.exports = __webpack_public_path__ + "static/media/IMG_1035.8fffb2ee.jpg";